import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { PersonalDataSection } from "@/components/profile/personal-data/personal-data-section";
import { AddressSection } from "@/components/profile/personal-data/address-section";

import type { JSX } from "react";

const UsuarioDadosPessoaisQuery = graphql(/* GraphQL */ `
  query UsuarioDadosPessoais {
    usuarios {
      ...PersonalDataSectionFragment
      ...AddressSectionFragment
    }
  }
`);

const PersonalDataPage = (): JSX.Element => {
  const queryResult = useGraphQL(UsuarioDadosPessoaisQuery, {});

  const { data } = queryResult;
  const usuario = data?.usuarios[0];

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Dados Pessoais" align="center" />
      </HeaderRoot>
      <Page className="px-6 py-8">
        <AsyncDataWrapper {...queryResult}>
          {usuario ? (
            <div className="flex flex-col gap-8">
              <PersonalDataSection data={usuario} />
              <AddressSection data={usuario} />
            </div>
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/personal-data/")({
  component: PersonalDataPage,
});
